import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row-span-1 col-span-1 flex flex-row w-full items-center border-b-2 border-gray-200 pl-4" }
const _hoisted_2 = { class: "relative h-full w-full max-w-sm flex items-center justify-center" }
const _hoisted_3 = { class: "absolute right-0 inset-y-0 flex items-center justify-center px-2" }
const _hoisted_4 = { class: "ml-4 flex flex-row items-center justify-center gap-4" }

import { Switch } from '@/components/ui/switch';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Filter, Search } from 'lucide-vue-next';
import { Input } from '@/components/ui/input';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import { GET_SESSIONS, GET_WHO_AM_I } from '@/store';
import { CustomerSession, isSessionExpired } from '@/http/customerSession';
import ScrollableSessions from '@/components/converza-sessions/tabs/ScrollableSessions.vue';

type TabsNames = "aguardando" | "atendendo";

export default /*#__PURE__*/_defineComponent({
  __name: 'ConverzaSessionsTabs',
  setup(__props) {

const currentTab = ref<TabsNames>("aguardando");

const store = useStore();

const sortSessions = (sessions: CustomerSession[]) => {
  return sessions.sort((a: CustomerSession, b: CustomerSession) =>
    (new Date(b.conversation.at(-1)?.dateTime ?? Date.now()).getTime()) - (new Date(a.conversation.at(-1)?.dateTime ?? Date.now()).getTime())
  );
};

const sessions = computed<CustomerSession[]>(() => Object.values(store.getters[GET_SESSIONS]));
const waitingSessions = computed<CustomerSession[]>(() => sortSessions(
  sessions.value.filter((session: CustomerSession) => session.whoIsChatting === null && session.status === 'OPEN_SUPPORT' && !isSessionExpired(session)))
);
const mySessions = computed<CustomerSession[]>(() => sortSessions(sessions.value
  .filter((session: CustomerSession) => session.whoIsChatting === store.getters[GET_WHO_AM_I] && session.status !== 'FINISHED' && !isSessionExpired(session))
));

const toggleCurrentTab = (value: TabsNames) => {
  currentTab.value = value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tabs), {
    modelValue: currentTab.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentTab).value = $event)),
    class: "min-w-[360px] grid max-lg:grid-rows-9 lg:grid-rows-12 grid-cols-1"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Input), {
            class: "pl-4 max-h-[85%]",
            id: "search",
            type: "text",
            placeholder: "Pesquisar"
          }),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_unref(Search), { class: "size-6 text-muted-foreground" })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Filter)),
          _createVNode(_unref(Switch), { class: "mr-3" })
        ])
      ]),
      _createVNode(_unref(TabsList), { class: "row-span-1 col-span-1 flex bg-transparent text-nowrap max-w-full" }, {
        default: _withCtx(() => [
          _createVNode(_unref(TabsTrigger), {
            value: "aguardando",
            class: "flex-1 text-center text-black-700 font-semibold text-sm leading-6",
            onClick: _cache[0] || (_cache[0] = () => toggleCurrentTab('aguardando'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Aguardando ")
            ]),
            _: 1
          }),
          _createVNode(_unref(TabsTrigger), {
            value: "atendendo",
            class: "flex-1 text-center text-black-700 border-gray-2 font-semibold text-sm leading-6",
            onClick: _cache[1] || (_cache[1] = () => toggleCurrentTab('atendendo'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Atendendo ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(TabsContent), {
        class: "max-lg:row-span-7 lg:row-span-10 col-span-1",
        value: "aguardando"
      }, {
        default: _withCtx(() => [
          _createVNode(ScrollableSessions, {
            sessions: waitingSessions.value,
            onTOGGLE_TAB: _cache[2] || (_cache[2] = () => toggleCurrentTab('atendendo')),
            currentTab: currentTab.value
          }, null, 8, ["sessions", "currentTab"])
        ]),
        _: 1
      }),
      _createVNode(_unref(TabsContent), {
        class: "row-span-7 col-span-1",
        value: "atendendo"
      }, {
        default: _withCtx(() => [
          _createVNode(ScrollableSessions, {
            sessions: mySessions.value,
            mine: true,
            currentTab: currentTab.value
          }, null, 8, ["sessions", "currentTab"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})